import { render, staticRenderFns } from "./ShorexIntroList.vue?vue&type=template&id=f6b30262&scoped=true"
import script from "./ShorexIntroList.vue?vue&type=script&lang=js"
export * from "./ShorexIntroList.vue?vue&type=script&lang=js"
import style0 from "./ShorexIntroList.vue?vue&type=style&index=0&id=f6b30262&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b30262",
  null
  
)

export default component.exports